import type {
  CreatorCancellationApiDetail,
  CreatorCancellationOrder,
} from "@/interface/collaborationCancellation";
import { OrderCancelType } from "@/interface/order";

export const getRawCreatorCancellation = (
  order?: CreatorCancellationOrder | null,
): CreatorCancellationApiDetail | undefined => order?.creatorCancellation;

export const hasCreatorCancellation = (
  order?: CreatorCancellationOrder | null,
) => {
  return (
    Boolean(order?.creatorCancellation) ||
    order?.cancelType === OrderCancelType.CreatorCancelled
  );
};
